/**
 *
 * SelectFieldAxios
 *
 */

import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Select, Spin, Empty } from 'antd';
const { Option } = Select;

// assets
//import CustomIcons from 'components/CustomIcons';

// utils
import { sortByKey } from 'utils/helpers/helper.general';
import api, { setAuthorizationHeader } from 'utils/apis/axiosAPI';
import { useAsync } from 'utils/hooks';

function SelectFieldAxios({
  mode,
  sortBy,
  endponit,
  endponitSend,
  item,
  placeholder,
  isSearch,
  // actions
  getPopupContainer,
  tagRender,
  itemCallback,
  onSelect,
  onChange,
  getResponse,
  className,
}) {
  const childClassNames = classNames('select-axios-wrapper', className);

  const { isLoading, isSuccess, run, data, reset } = useAsync();

  const [listOptions, setListOptions] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem('schoolinked_user'));
  const token = currentUser?.token;
  setAuthorizationHeader(token);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    return () => {
      setListOptions([]);
      reset();
    };
  }, []);
  

  /**
  * Loading data for rendering in a component
  * - work like ComponentDidUpdate
  */
  useEffect(() => {
    if (!isLoading && (endponit || (endponit && endponitSend))) {
      run(api.route.fetchAll(endponit, endponitSend));
    }
  }, [endponit, endponitSend]);

  /**
  * Loading data for rendering in a component
  * - work like ComponentDidUpdate
  */
  useEffect(() => {
    if (data) {
      getResponse !== undefined && getResponse({isLoading, isSuccess, data});
      const optioins = data.map(elem => itemCallback(elem));
      const mainOpt = optioins.filter(el => el !== null && el);
      // sort options
      sortBy !== undefined && mainOpt && mainOpt.sort(sortByKey(sortBy));
      setListOptions(mainOpt);
    }
  }, [data]);

  const multipleOptions = mode && {
    mode: mode,
    maxTagCount: 3, // 'responsive'
  };

  mode && tagRender && (multipleOptions.tagRender = tagRender);

  const selectLocale = {
    emptyText: (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={'Aucune donnée'}
      />
    ),
  };

  return (
    <>
      {isSuccess && (
        <Form.Item
          key={item?.name + '-item'}
          label={item?.displayLabel ? item?.label : ''}
          name={item?.name}
          className={childClassNames}
          initialValue={item.value || (mode && tagRender) ? [] : null}
          rules={[
            {
              required: item?.required || false,
              message: 'Veuillez sélectionner le champ requis',
            },
          ]}
        >
          <Select
            locale={selectLocale}
            placeholder={placeholder || 'Sélectionner'}
            optionFilterProp="children"
            onSelect={onSelect}
            onChange={onChange}
            showArrow
            showSearch={isSearch}
            optionLabelProp={item.optionLabelProp || 'label'}
            loading={isLoading}
            getPopupContainer={trigger => trigger.parentElement}
            notFoundContent={
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'Aucune donnée'}
              />
            }
            filterOption={(input, option) => {
              return (
                (option?.title &&
                  option?.title.toLowerCase().indexOf(input.toLowerCase()) >=
                    0) ||
                (option?.label &&
                  option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0)
              );
            }}
            {...multipleOptions}
          >
            {listOptions.map((option, i) => (
              <Option
                {...option}
                key={option?.key || option?.value}
                value={option?.value || option?.key}
                label={option?.label || option?.title || option?.value}
              >
                {
                  <span
                    className="option"
                    dangerouslySetInnerHTML={{
                      __html: option?.title || option?.label || option?.value,
                    }}
                  />
                }
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}
      {isLoading && <Spin />}
    </>
  );
}

SelectFieldAxios.defaultProps = {
  isSearch: true
};
SelectFieldAxios.propTypes = {
  sortBy: PropTypes.string,
  isSearch: PropTypes.bool,
};

export default memo(SelectFieldAxios);